"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = void 0;
const getCookie = cookieName => {
  const match = document.cookie.match(new RegExp(`${cookieName}=([^;]+)`));
  return match ? match[1] : undefined;
};
exports.getCookie = getCookie;
